import { render, staticRenderFns } from "./newSpecial.vue?vue&type=template&id=629aec60&scoped=true&"
import script from "./newSpecial.vue?vue&type=script&lang=js&"
export * from "./newSpecial.vue?vue&type=script&lang=js&"
import style0 from "./newSpecial.vue?vue&type=style&index=0&id=629aec60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629aec60",
  null
  
)

export default component.exports